import type { SkillCategory } from 'types/bio';
import styles from './abilityitem.module.scss';

interface AbilityItemProps {
  category: SkillCategory;
}

const AbilityItem: React.FC<AbilityItemProps> = ({ category }) => {
  return (
    <div className={styles.sectionContainer}>
      <div className={styles.abilityItemRoot}>
        <div className={`${styles.gridItem} ${styles.category}`}>{category.category}</div>
        <div className={`${styles.gridItem} ${styles.skillList}`}>
          {category.skills.join(', ')}
        </div>
      </div>
    </div>
  );
};

export default AbilityItem;
